<template>
  <div>
    <PageTitle title="Map" />

    <hr>

    <b-container fluid="xxl">
      <div>
        <b-row>
          <b-col>
            <LocationSelect
              class="selectLocationElement"
              ref="selectLocation"
              @select="selectLocation"
              settings="{ inMap: true }"
            />
          </b-col>
          <b-col>
            <b-button
              v-if="config.editable"
              id="saveButton"
              variant="primary"
              :disabled="!savable"
              @click="saveLocation"
              size="sm">
              Save Geo-Location
            </b-button>

            <b-button
              id="showAllButton"
              variant="primary"
              @click="showAll"
              size="sm">
              Deselect / Show All
            </b-button>

          </b-col>
          <!-- <b-col>
            <span>current Position: {{ curPos }}</span>
          </b-col> -->
        </b-row>
        <b-row style="margin-top: 5px">
          <b-col cols="2" id="selectNAAF">
            <Select2
              :settings="naafSettings"
              :options="naafOptions"
              @select="selectNAAF($event)"
            />
          </b-col>

        </b-row>
      </div>

      <hr>

      <div>
        <b-tabs v-model="tabIndex">
          <b-tab :title="tabType[0]" active>
          </b-tab>
          <b-tab :title="tabType[1]">
          </b-tab>
          <b-tab :title="tabType[2]">
          </b-tab>
          <b-tab :title="tabType[3]">
          </b-tab>
        </b-tabs>
        <b-row class="tabrow">
          <b-col cols="3">
            <div>
              <!-- .slice() is needed to avoid infinite update loop  -->
              <Select2
                :options="groupOptions"
                :placeholder="`Select ${title}`"
                @select="setGroup($event)"
                tabindex="0"
              />
            </div>
          </b-col>
        </b-row>
      </div>

      <div v-if="dataBins.length > 0">
        <hr>

        <b-row>
          <b-col cols="3">
            <div>
              <Select2
                :options="scriptoriaTypesOptions"
                :settings="scriptoriaTypesSettings"
                v-model="scriptoriaTypes"
                placeholder="Select Scriptoria Types"
                tabindex="0"
              />
            </div>
          </b-col>
        </b-row>

        <b-row style="margin-top: 5px">
          <b-col cols="2">
            <router-link
              :to="{ name: 'ParameterDetails', params: {
                  parameterId: group
                }
              }"
              v-html="groupName"
              v-if="tabIndex === 0"
              target="_blank"
            />
            <span
              v-html="groupName"
              v-if="tabIndex > 0"
            />
          </b-col>

          <b-col cols="2" v-for="bin in dataBins" :key="bin">
            <div style="display: flex; align-items: center; margin: 4px 0;">
              <div>{{ bin }}</div>
              <input type="color" :value="groupColors[bin]" @input="selectColor" :bin="`${bin}`"/>
              <select style="margin-left: 4px" class="bin-factor" :v-model="`${bin}-factor`" :bin="`${bin}`">
                <option>1</option>
                <option>5</option>
                <option>10</option>
                <option>20</option>
                <option>50</option>
              </select>
            </div>
          </b-col>
        </b-row>

        <b-row style="margin-top: 5px" v-if="group">
          <b-col>
            <b-button
              v-if="dataBins.length > 0"
              variant="primary"
              @click="getGroupData"
              size="sm"
            >
              Fetch Data
            </b-button>
          </b-col>
        </b-row>
      </div>

      <div v-if="dataTimeLocations.length > 0">
        <hr>

        <b-row style="margin-top: 8px">
          <b-col>
            <div>
              Pie Size
              <vue-slider v-model="pieSize" :min="10" :max="100" :process="false" :tooltip="'none'"/>
            </div>
          </b-col>

          <b-col>
            <div>
              <select v-model="scalePies">
                <option>uniform</option>
                <option>relative</option>
                <option>categorized</option>
                <option>log</option>
              </select>
              Scale Pie Size
            </div>
          </b-col>

          <b-col>
            <div>
              <label for="range-1">Year Span: {{ this.yearSpan[0] }} to {{ this.yearSpan[1] }}</label>
              <vue-slider v-model="yearSpan" :min="1100" :max="1600" :fixed="sliderIsFixed"/>
              <b-form-checkbox
                v-model="sliderIsFixed"
                switch
              >fix range</b-form-checkbox>
            </div>
          </b-col>
        </b-row>
      </div>

      <hr>

      <div id="mapContainer">
        <l-map
          ref="Map"
          :zoom="zoom"
          :minZoom="5"
          :center="center"
          style="height: 90%"
          :maxBounds="maxBounds"
          @update:center="centerUpdate"
          @update:zoom="zoomUpdate"
          @click="addMarker"
          @ready="onMapReady"
        >
          <l-tile-layer
            id="map"
            :url="url"
            :attribution="attribution"
          />

          <l-marker
            v-for="curLoc in currentGeoLocation"
            :key="curLoc[0]"
            :lat-lng="curLoc"
            :draggable="true"
            :icon="myMarkerIcon"
            @dragend="getMarkerPosition">
          </l-marker>

          <l-marker
            v-for="loc in allGeoLocations"
            :key="loc[0]"
            :lat-lng="[loc.latitude, loc.longitude]"
            :icon="myMarkerIcon"
            >
            <l-popup :content="loc.display"></l-popup>
          </l-marker>

        </l-map>
      </div>
    </b-container>
  </div>

</template>

<style scoped>
  >>> .select2-container {
      width: 100% !important;
  }

  .tabrow {
    margin-top: 15px;
  }

  .leaflet-layer {
    position: absolute;
    left: 0;
    top: 0;
    }
  .invalidYear {
    background-color: orange;
  }
  #mapContainer {
    width: 90%;
    height: 1020px;
    border-radius: 7px;
    margin: auto;
  }
  #saveButton {
    margin-right:10px;
  }
  #showAllButton {
    margin-right:10px;
  }
</style>

<script>
  import { mapState }                          from 'vuex'
  import PageTitle                             from '@/components/PageTitle.vue'
  import axios                                 from 'axios'
  import LocationSelect                        from '@/components/Main/LocationSelect.vue'
  import "leaflet/dist/leaflet.css";
  import { latLng }                            from "leaflet";
  import L                                     from "leaflet";
  import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
  import {SimpleMapScreenshoter}               from 'leaflet-simple-map-screenshoter'
  import config                                from '@/config.js'
  import $                                     from "jquery";
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/default.css'
  // import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet";

  export default {
    name: 'LocationsList',
    data(){
      const myMarkerIcon = L.icon({
         iconUrl: require('leaflet/dist/images/marker-icon.png'),
         shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
         iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
         iconSize: [25, 41],
         iconAnchor: [12, 41]
      });
      return {
        zoom: 7,
        allZoom: 6,
        maxZoom: 10,
        center: latLng(46.98766, 3.15772),
        maxBounds: [
            [62.01447753807476, -24.4854345428153435],
            [30.3782598746379, 29.98511485959183],
          ],
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution:
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        // withPopup: latLng(48.856614, 2.352222),
        // withTooltip: latLng(47.484227, 4.241990),
        allParameters: [],
        allCategoryGroups: [],
        allLemmaGroups: [],
        allTypeGroups: [],
        allCategories: [
          {id: 'e18c418f-7b2a-4309-bb95-6907c23adb6f', text: 'Les rites et les cultes'},
          {id: '0a4529c1-8f69-482a-94b7-d6d2de1dd1e0', text: 'Le commerce, la finance'},
          {id: 'e3d2f626-6040-44d9-a10a-b825d1a24656', text: 'Les cours d’eau et les constructions'},
          {id: '7d44973e-9245-4ced-973b-c9ce093c2690', text: 'Les mesures, les poids'},
          {id: '2d73bceb-2089-454d-bf4c-261ee4d9bf99', text: 'La législation'},
          {id: '7d6b7a3a-ddc6-4751-971b-b8853cb44aa8', text: 'Le gouvernement, l’administration'},
          {id: '2865f632-ec60-450c-89f4-973ffffb56bb', text: 'Les différents métiers et professions'},
          {id: 'e5040e1c-a89d-421a-bde7-3163f4336412', text: 'Les procédés judiciaires'},
          {id: '6cb79538-bb7e-4b6f-9b2d-079fdf34825a', text: 'Les terrains et leur constitution'},
          {id: '6c1acc7c-f4ba-4cfe-8000-a0bc298eb1f1', text: 'La forêt, les arbres forestiers et les autres arbres dont on utilise le bois, etc.'},
          {id: '6567cf68-ae3d-4f6f-9e5f-99aa582ca36c', text: 'La propriété'},
          {id: 'd28d5323-5beb-4f64-bd3b-5a4eb5d5dbd9', text: 'L’agriculture, l’élevage, le jardinage'},
          {id: '18f6a7a6-d3d9-4d66-822b-eb9e06b82910', text: 'Les eaux'},
          {id: 'c94293ba-e5bd-4c0b-8a4d-820ff065344f', text: 'Le sol'},
          {id: 'f44aa148-3f27-46ec-b63b-4f896ba8ac2a', text: 'L’espace'},
          {id: '3fb7af55-bc90-4237-b9c4-a52cd2ca2cc9', text: 'Le pâturage'},
          {id: 'ae0850db-0758-4e61-9b6f-17a16ad4d6ba', text: 'Le mouvement'},
        ],
        group: null,
        aggregateLocs: false,
        scalePies: 'uniform',
        parameterName: null,
        pieSize: 30,
        dataBins: [],
        currentGeoLocation: [],
        allGeoLocations: [],
        dataTimeLocations: [],
        dataLocations: [],
        maxCount: null,
        categorizedPiesLegend: null,
        fixColors: [
          "#E8B520", // golden yellow
          "#5AAD5A", // fresh green
          "#2AADD4", // ocean blue
          "#E8822A", // burnt orange
          "#2AAD8F", // teal
          "#9B6CBD", // medium lavender
          "#D45A7A", // rose pink
          "#4A85B8", // medium blue
          "#D4614A", // coral red
          "#B89A5A", // golden tan
          "#6AAD3A", // grass green
          "#B87840", // warm brown
        ],
        groupColors: {},
        currentZoom: 11.5,
        currentCenter: latLng(46.98766, 3.15772),
        myMarkerIcon: myMarkerIcon,
        // curPos: null,
        savable: false,
        scriptoriaTypesOptions: ['Clergé régulier', 'Clergé séculier', 'Noblesse', 'Ville'],
        scriptoriaTypesSettings: {'multiple': true, 'allowClear': true},
        scriptoriaTypes: [],
        yearSpan: [1100, 1600],
        sliderIsFixed: false,
        selectedLocation: null,
        screenshotter: null,
        config: config,
        naafOptions: Array.from({ length: 73 }, (value, index) => index + 1),
        naafSettings: {
          placeholder: "NAAF 73",
        },

        tabIndex: 0,
        tabType: ["Parameter", "Category", "Lemma", "Type"]
      }
    },
    computed: {
      ...mapState({
        userSettings: state => state.user.settings
      }),
      title() {
        return `${ this.tabType[this.tabIndex] }${ this.tabIndex > 0 ? ' Group' : '' }`
      },
      groupOptions() {
        let dataSet

        if (this.tabIndex === 0) {
          dataSet = this.allParameters
        } else if (this.tabIndex === 1) {
          dataSet = this.allCategoryGroups
        } else if (this.tabIndex === 2) {
          dataSet = this.allLemmaGroups
        } else if (this.tabIndex === 3) {
          dataSet = this.allTypeGroups
        }

        return dataSet
          .slice().sort((a, b) => Intl.Collator().compare(a.name, b.name))
          .map(param => ({id: param.id, text: param.name}))
      }
    },
    components: {
      PageTitle,
      LMap,
      LTileLayer,
      LMarker,
      LocationSelect,
      LPopup,
      VueSlider
      //LTooltip
    },
    mounted() {
      this.loadDataToSelect()
    },
    methods: {
      selectColor(event) {
        const bin             = event.target.getAttribute("bin")
        this.groupColors[bin] = event.target.value
        this.renderTimeData()
      },
      lemmaSelect(lemma) {
        if (this.lemma.map(x => x.id).includes(lemma.id)) {
          this.lemma = this.lemma.filter(x => x.id !== lemma.id)
        } else {
          this.lemma.push(lemma)
        }

        this.lemmaLocations = []
        this.lemmaBins      = []
      },
      onMapReady() {
        const map = this.$refs.Map.mapObject;
        map.options.zoomDelta = 0.1;
        map.options.zoomSnap = 0.1; // Also set this for smooth zooming
        this.pieChartLayer = window.L.layerGroup().addTo(map);
      },
      async setGroup(event) {
        this.group             = event.id
        this.groupName         = event.text
        this.dataTimeLocations = []

        if (this.screenshotter) this.screenshotter.remove()
        this.screenshotter = new SimpleMapScreenshoter({screenName: this.groupName}).addTo(this.$refs.Map.mapObject)
        this.screenshotter.takeScreen('image', {
          scale: 0.5,
          hidden: true
        });

        await this.$store.dispatch(`load${this.tabType[this.tabIndex]}Bins`, this.group)
        this.dataBins = this.$store._vm._data.$$state.location.dataBins
        for (let i = 0; i < this.dataBins.length; i++ ) {
          this.groupColors[this.dataBins[i]] = this.fixColors[i]
        }
      },
      loadDataToSelect() {
        axios
          .get(config.apiUrl + '/parameters/complete')
          .then((response) => {
            this.allParameters = response.data.map(x => {return {id: x.parameterId, ...x}})
          })

        axios
          .get(config.apiUrl + '/categories/groups')
          .then((response) => {
            this.allCategoryGroups = response.data.map(x => {return {id: x.categorygroupId, ...x}})
          })

        axios
          .get(config.apiUrl + '/lemmas/groups')
          .then((response) => {
            this.allLemmaGroups = response.data.map(x => {return {id: x.lemmagroupId, ...x}})
          })

        axios
          .get(config.apiUrl + '/token/types/groups')
          .then((response) => {
            this.allTypeGroups = response.data.map(x => {return {id: x.typegroupId, ...x}})
          })
      },
      async selectNAAF(event) {
        this.cleanGlobals()
        this.cleanGroupGlobals()
        await this.$store.dispatch('loadNAAFLocations', event.id)
        this.allGeoLocations = this.$store._vm._data.$$state.location.allGeoLocations;
        this.$refs.Map.mapObject.setView(this.center, this.allZoom);
        // this.$refs.selectLocation.select()
        $("#select-location select").val("").change() // deselects location select select2 component
      },
      pruneFloat(number) {
      if (number) {
        let numStr = number.toString();
        const decPoint = numStr.indexOf(".");
        return numStr.split("").splice(0, decPoint+4).join("")
      }
        return number;
      },
      zoomUpdate(zoom) {
        this.currentZoom = zoom;
      },
      centerUpdate(center) {
        this.currentCenter = center;
      },
      addMarker(event) {
        if (this.selectedLocation) {
          //this.curPos = `${this.pruneFloat(event.latlng.lat)}, ${this.pruneFloat(event.latlng.lng)}`;
          this.currentGeoLocation = [event.latlng];
          this.allGeoLocations = [];
          this.savable = true;
        }
      },
      getMarkerPosition(marker) {
        // this.curPos = `${this.pruneFloat(marker.target._latlng.lat)}, ${this.pruneFloat(marker.target._latlng.lng)}`;
        this.currentGeoLocation = [marker.target._latlng];
        this.savable = true;
      },
      centerMap(newCenter) {
        if (newCenter) {
          this.$refs.Map.mapObject.setView(newCenter, this.zoom);
        } else {
          this.$refs.Map.mapObject.setView(this.center, this.zoom);
        }
      },
      selectLocation(location) {
        $("#selectNAAF select").val("").change() // deselects location select select2 component
        this.cleanGlobals()
        this.cleanGroupGlobals()
        if (location.latitude && location.longitude) {
          const newLoc = latLng(location.latitude, location.longitude)
          this.currentGeoLocation = [newLoc];
          // this.curPos = `${this.pruneFloat(location.latitude)}, ${this.pruneFloat(location.longitude)}`
          this.centerMap(newLoc);
        } else {
          this.currentGeoLocation = [];
          // this.curPos = null;
          this.centerMap(null);
        }
        this.selectedLocation = location
      },
      saveLocation() {
        this.$bvModal.msgBoxConfirm('Save Geo-Location for selected Location?').then(value => {
          if (value) {
            this.selectedLocation.latitude  = this.currentGeoLocation[0].lat;
            this.selectedLocation.longitude = this.currentGeoLocation[0].lng;
            this.$store.dispatch('saveLocation', this.selectedLocation).then(() => {
              this.$store.dispatch('addNotification', {
                type: 'success',
                text: `Geo-Location saved`
                })
              })
          }})
        this.savable = false;
      },
      createPieChart(data, total, size = 80) {

        let currentAngle = -90 // Start from top
        const center = size / 2
        const radius = size / 2

        if (Object.entries(data).length === 1) {
          return `
            <svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
              <circle cx="${center}" cy="${center}" r="${radius}" fill="${this.groupColors[Object.keys(data)[0]]}" stroke="white" stroke-width="2"/>
            </svg>
          `;
        }

        const paths = Object.entries(data).sort((a, b) => Intl.Collator().compare(a[0], b[0])).map(([key, value]) => {
          const percentage = value / total
          let angle = percentage * 360

          const startAngle = currentAngle * Math.PI / 180
          const endAngle = (currentAngle + angle) * Math.PI / 180
          
          const x1 = center + radius * Math.cos(startAngle)
          const y1 = center + radius * Math.sin(startAngle)
          const x2 = center + radius * Math.cos(endAngle)
          const y2 = center + radius * Math.sin(endAngle)
          
          const largeArc = angle > 180 ? 1 : 0
          
          const pathData = [
            `M ${center} ${center}`,
            `L ${x1} ${y1}`,
            `A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2}`,
            'Z'
          ].join(' ')
          
          currentAngle += angle
          
          return `<path d="${pathData}" fill="${this.groupColors[key]}" stroke="white" stroke-width="1.5"/>`;
        }).join('')

        return `
          <svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
            <circle cx="${center}" cy="${center}" r="${radius}" fill="white" stroke="#e5e7eb" stroke-width="2"/>
            ${paths}
          </svg>
        `
      },
      cleanGroupGlobals() {
        this.dataLocations = []
        this.dataBins      = []
        this.group         = null
        this.groupName     = null
      },
      cleanGlobals() {
        this.dataTimeLocations  = []
        this.allGeoLocations    = []
        this.currentGeoLocation = []
        this.selectedLocation   = null
        this.savable            = false
        this.pieChartLayer.clearLayers()
        if (this.categorizedPiesLegend) this.categorizedPiesLegend.remove()
      },
      tagsTotal2pixels(numTags) {
        return (numTags <   10) ?   5 :
               (numTags <  100) ?  10 :
               (numTags < 1000) ?  20 :
               (numTags < 5000) ?  50 :
                                  100
        
      },
      async getGroupData() {
        const factors = document.getElementsByClassName('bin-factor')
        const factorObj = Object.fromEntries([...factors].map(x => [x.getAttribute('bin'), x.value]))
        this.cleanGlobals()
        $("#selectNAAF select").val("").change() // deselects location select select2 component
        $("#select-location select").val("").change() // deselects location select select2 component

        await this.$store.dispatch(`loadGroupData`, {
          type: this.tabType[this.tabIndex],
          groupId: this.group,
          factors: factorObj,
          scriptoriaTypes: this.scriptoriaTypes
        })
        this.dataTimeLocations = this.$store._vm._data.$$state.location.dataTimeLocations
        this.maxCount          = this.max(this.dataTimeLocations.map(x => Object.values(x.total).reduce((x, y) => x + y, 0)))
        this.dataBins          = this.$store._vm._data.$$state.location.dataBins
      },
      max(list) {
        return list.reduce((a, b) => a > b ? a : b, list[0])
      },
      categorizeSize(count) {
        return (count <   10) ?   0.5 :
               (count <  100) ?   1   :
               (count < 1000) ?   2   :
                                  3
      },
      log(count) {
        if (count == 1) {
          return 0.15
        } else {
          return Math.log2(count)
        }
      },
      areaRatioToDiameter(ratio, mainDiameter) {
        return 2 * ((mainDiameter / 2) * Math.sqrt(ratio))
      },
      compRelative(count, max) {
        return this.areaRatioToDiameter(count / max, this.pieSize * 2) 
      },
      compCategorize(count) {
        return this.pieSize * this.categorizeSize(count)
      },
      compLog(count, max) {
        return this.areaRatioToDiameter(this.log(count) / this.log(max), this.pieSize * 2)
      },
      renderTimeData() {
        this.pieChartLayer.clearLayers()

        if (this.categorizedPiesLegend) this.categorizedPiesLegend.remove()

        if (!this.dataLocations) return null

        this.dataLocations.forEach(loc => {
          let defPieSize

          switch (this.scalePies) {
            case ('relative'):    defPieSize = this.compRelative(loc.total, this.maxCount); break;
            case ('uniform'):     defPieSize = this.pieSize; break;
            case ('categorized'): defPieSize = this.compCategorize(loc.total); break
            case ('log'):         defPieSize = this.compLog(loc.total, this.maxCount); break
          }

          const pieChartSVG = this.createPieChart(loc.data, loc.total, defPieSize)

          const icon = window.L.divIcon({
            html: pieChartSVG,
            className: 'pie-chart-marker',
            iconSize: [defPieSize, defPieSize],
            iconAnchor: [defPieSize / 2, defPieSize / 2]
          });

          let locName;
          let nalfnum = this.aggregateLocs ? '[<strong>' + loc.nalf + '</strong>] ' : ''
          if (loc.town && loc.department) {
            locName = `${nalfnum}<small>Town:</small> ${loc.town} (<small>Dep:</small> ${loc.department})`
          } else if (loc.town) {
            locName = `${nalfnum}<small>Town:</small> ${loc.town}`
          } else {
            locName = `${nalfnum}<small>Dep:</small> ${loc.department}`
          }

          const popupContent = `
              <div style="font-family: system-ui, -apple-system, sans-serif;">
                <h3 style="margin: 0 0 10px 0; font-size: 16px; font-weight: 600;">${locName}</h3>
                <div style="font-size: 13px;">
                  ${Object.entries(loc.data).sort((x, y) => y[1] - x[1]).map(([key, value]) => `
                    <div style="display: flex; align-items: center; margin: 4px 0;">
                      <div style="width: ${2 * Math.round(value/loc.total*100)}px; height: 12px; background: ${this.groupColors[key]}; margin-right: 6px; border-radius: 2px;"></div>
                      <span><strong>${key}</strong>: ${Intl.NumberFormat("de-CH").format(value)} (${Math.round(value/loc.total*100)}%)</span>
                    </div>
                  `).join('')}
                </div>
                <div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #e5e7eb; font-size: 12px; color: #6b7280;">
                  Total: ${Intl.NumberFormat("de-CH").format(loc.total)}
                </div>
                <div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #e5e7eb; font-size: 12px; color: #6b7280;">
                  <ul>
                    ${Object.values(loc.scriptoria ?? {}).filter(x => x.totalTags > 0).sort((x, y) => x.name > y.name ? 1 : -1).map(scr => `
                      <li type="i">
                        <a href="/#/scriptorium/${scr.id}?type=${this.tabType[this.tabIndex].toLowerCase()}&id=${encodeURIComponent(this.group)}&colors=${encodeURIComponent(JSON.stringify(this.groupColors))}" target="_blank">${scr.name} <small>(${Intl.NumberFormat("de-CH").format(scr.totalTags)})</small></a>
                          <div style="display: flex; height: ${this.tagsTotal2pixels(scr.totalTags)}px; border-radius: 4px; overflow: hidden; margin-bottom: 2px;">
  							          ${Object.entries(scr.tags).sort((x, y) => y[1] - x[1]).map(([k, v]) => `
                            <div style="width: ${2 * (v / scr.totalTags * 100)}px; background: ${this.groupColors[k]};"></div>
                          `).join('')}
                          </div>
                      </li>
                    `).join('')}
                  </ul>
                </div>
              </div>`

          window.L.marker([loc.latitude, loc.longitude], { icon })
            .bindPopup(popupContent)
            .addTo(this.pieChartLayer);
      
        })

        if (this.scalePies !== 'uniform' && this.maxCount) {
          this.categorizedPiesLegend = window.L.control()
          const that = this

          this.categorizedPiesLegend.onAdd = function () {
            let threshs

            if (that.scalePies === 'relative' || that.scalePies === 'log') {
              let upper

              if (that.maxCount < 50) {
                threshs = [[5, '5'], [15, '15'], [50, '50']]
              } else if (that.maxCount < 100) {
                threshs = [[10, '10'], [20, '20'], [100, '100']]
              } else if (that.maxCount < 500) {
                upper   = (that.maxCount / 100).toFixed() * 100
                threshs = [[10, '10'], [100, '100'], [upper, upper.toString()]]
              } else if (that.maxCount < 1000) {
                upper   = (that.maxCount / 100).toFixed() * 100
                threshs = [[10, '10'], [200, '200'], [upper, upper.toString()]]
              } else {
                upper   = (that.maxCount / 1000).toFixed() * 1000
                threshs = [[10, '10'], [200, '100'], [1000, '1000'], [upper, upper.toString()]]
              }
            }

            if (that.scalePies === 'categorized') {
              threshs = [[9, '< 10'], [99, '10 - 100'], [999, '100 - 1000'], [1000, '>= 1000']].map(([radius, label]) => [that.compCategorize(radius), label])
            } else if (that.scalePies === 'relative') {
              threshs = threshs.map(([radius, label]) => [that.compRelative(radius, that.maxCount), label])
            } else if (that.scalePies === 'log') {
              threshs = threshs.map(([radius, label]) => [that.compLog(radius, that.maxCount), label])
            }

            const div = L.DomUtil.create('div', 'info legend')
            const strokePad = 2
            const maxR = Math.max(...threshs.map(x => x[0]))

            const cx = maxR + strokePad
            const topY = strokePad
            const lineLength = 20
            const lineEndX = cx + maxR / 2 + lineLength
            const labelX = lineEndX + 4

            const svgWidth = labelX + 60
            const svgHeight = topY + maxR * 2 + strokePad * 2

            const sorted = threshs
              .map(([radius, label]) => ({ radius: radius / 2, label }))

            const circles = sorted
              .map(({ radius }) => {
                const cy = topY + radius
                return `<circle cx="${cx}" cy="${cy}" r="${radius}" fill="none" stroke="gray" stroke-width="2"/>`
              })
              .join('')

            const connectors = sorted
              .map(({ radius, label }) => {
                const bottomY = topY + 2 * radius;       // bottom point of this circle
                return `
                  <line x1="${cx}" y1="${bottomY}" x2="${lineEndX}" y2="${bottomY}" stroke="gray" stroke-width="2"/>
                  <text x="${labelX}" y="${bottomY}" font-size="12" stroke="black" stroke-width="1" dominant-baseline="middle">${label}</text>
                `
              })
              .join('')

            div.innerHTML = `
              <svg width="${svgWidth}" height="${svgHeight}" xmlns="http://www.w3.org/2000/svg">
                ${circles}
                ${connectors}
              </svg>`

            return div
          }

          this.categorizedPiesLegend.addTo(this.$refs.Map.mapObject);
        }
      },
      async showAll() {
        this.cleanGroupGlobals()
        this.cleanGlobals()
        if (this.allGeoLocations.length == 0) {
          await this.$store.dispatch('allGeoLocations')
          this.allGeoLocations = this.$store._vm._data.$$state.location.allGeoLocations;
          this.$refs.Map.mapObject.setView(this.center, this.allZoom);
        } else {
          this.allGeoLocations = [];
        }
        $("select").val("").change(); // deselects select2 component
      },
      mergeSum(...objs) {
      // https://stackoverflow.com/a/58441606
        return Object.fromEntries(
          Array.from(
            new Set(objs.flatMap(Object.keys)),
            k => [k,
              objs
                .map(o => o[k] || 0)
                .reduce((a, b) => a + b)
            ]))
      },
      computeData() {
        const [min, max] = this.yearSpan

        this.dataLocations = this.dataTimeLocations.map(x => {
          return {
            ...x,
            total: Object.entries(x.total)
                    .filter(a => a[0] >= min && a[0] <= max)
                    .map(a => a[1])
                    .reduce((a, b) => a + b, 0),
            data: this.mergeSum(...Object.entries(x.data)
                    .filter(a => a[0] >= min && a[0] <= max)
                    .map(a => a[1])),
            scriptoria: x.scriptoria.map(y => {
              return {
                ...y,
                totalTags: Object.entries(y.totalTags)
                            .filter(a => a[0] >= min && a[0] <= max)
                            .map(a => a[1])
                            .reduce((a, b) => a + b, 0),
                tags: this.mergeSum(...Object.entries(y.tags)
                            .filter(a => a[0] >= min && a[0] <= max)
                            .map(a => a[1]))
              }
            })
          }
        }).filter(x => x.total > 0)
      }
    },
    watch: {
      "yearSpan"() {
        this.computeData()
      },
      "userSettings"(){
        this.key++
      },
      "tabIndex"() {
        this.dataBins          = []
        this.dataTimeLocations = []
      },
      "dataTimeLocations"() {
        this.computeData()
      },
      "dataLocations"() {
        this.renderTimeData()
      },
      "pieSize"() {
        this.renderTimeData()
      },
      "scalePies"() {
        this.renderTimeData()
      },
    }
  }
</script>
